(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["old-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Update cart counter in real-time by observing the drawer element
  (function() {
    // Function to update the header counter based on the drawer counter value
    function updateCartCountBubble(itemCount) {
      const cartBubbles = document.querySelectorAll('.cart-count-bubble');
      
      cartBubbles.forEach((bubble) => {
        const parentLink = bubble.closest('a');
        if (!parentLink) return;

        // Update or create the counter
        if (itemCount > 0) {
          // Ensure the bubble is visible
          bubble.style.display = '';

          // Update the visible number
          let visibleSpan = bubble.querySelector('span[aria-hidden="true"]');
          if (itemCount < 100) {
            if (!visibleSpan) {
              visibleSpan = document.createElement('span');
              visibleSpan.setAttribute('aria-hidden', 'true');
              bubble.insertBefore(visibleSpan, bubble.firstChild);
            }
            visibleSpan.textContent = itemCount;
          } else {
            // If >= 100, remove the visible span
            if (visibleSpan) {
              visibleSpan.remove();
            }
          }

          // Update the accessible text
          let hiddenSpan = bubble.querySelector('span.visually-hidden');
          if (!hiddenSpan) {
            hiddenSpan = document.createElement('span');
            hiddenSpan.className = 'visually-hidden';
            bubble.appendChild(hiddenSpan);
          }
          const countText = itemCount === 1 ? 'item' : 'items';
          hiddenSpan.textContent = `${itemCount} ${countText}`;
        } else {
          // Hide the counter if the cart is empty
          bubble.style.display = 'none';
        }
      });

      // If no bubble exists, create one when necessary
      if (itemCount > 0 && cartBubbles.length === 0) {
        const cartLinks = document.querySelectorAll('a[href*="cart"], .ntg-cart-link');
        cartLinks.forEach((link) => {
          if (!link.querySelector('.cart-count-bubble')) {
            const newBubble = document.createElement('div');
            newBubble.className = 'cart-count-bubble';
            
            if (itemCount < 100) {
              const visibleSpan = document.createElement('span');
              visibleSpan.setAttribute('aria-hidden', 'true');
              visibleSpan.textContent = itemCount;
              newBubble.appendChild(visibleSpan);
            }
            
            const hiddenSpan = document.createElement('span');
            hiddenSpan.className = 'visually-hidden';
            hiddenSpan.textContent = `${itemCount} ${itemCount === 1 ? 'item' : 'items'}`;
            newBubble.appendChild(hiddenSpan);
            
            link.appendChild(newBubble);
          }
        });
      }
    }

    // Function to get the counter value from the drawer
    function getCartCountFromDrawer() {
      const cartCountElement = document.querySelector('.amp-cart__header-cart-count');
      if (!cartCountElement) return null;
      
      const text = cartCountElement.textContent?.trim() || '';
      const count = parseInt(text, 10);
      return isNaN(count) ? null : count;
    }

    // Observe changes in the amp-cart__header-cart-count element
    function observeCartCount() {
      const cartCountElement = document.querySelector('.amp-cart__header-cart-count');
      
      if (!cartCountElement) {
        // Try again after a delay if the element doesn't exist yet
        setTimeout(observeCartCount, 500);
        return null;
      }

      // Update immediately with the current value
      const currentCount = getCartCountFromDrawer();
      if (currentCount !== null) {
        updateCartCountBubble(currentCount);
      }

      // Create observer to detect changes
      const observer = new MutationObserver(() => {
        const newCount = getCartCountFromDrawer();
        if (newCount !== null) {
          updateCartCountBubble(newCount);
        }
      });

      // Observe changes in text and attributes
      observer.observe(cartCountElement, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: false
      });

      return observer;
    }

    // Initialize when DOM is ready
    function initCartCounterObserver() {
      observeCartCount();
      
      // Try again after a delay to ensure the element has loaded
      setTimeout(() => {
        observeCartCount();
      }, 1000);
      
      // Try once more after 2 seconds (in case the APP loads later)
      setTimeout(() => {
        observeCartCount();
      }, 2000);
    }

    // Execute when DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCartCounterObserver);
    } else {
      initCartCounterObserver();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
